/* Panels/UserDashboard/Pages/ProfileSuite/hooks/useUpload.js */
import { useSnackbar } from "notistack";
import axios from "axios";
import { useState } from "react";

export default function useUpload() {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const upload = async (fileList) => {
    if (!fileList?.length) return null;
    setLoading(true);
    const fd = new FormData();
    [...fileList].forEach(f => fd.append("files", f));

    try {
      const { data } = await axios.post(
        "https://aws-calendia-bc10efcc84bf.herokuapp.com/api/deck/upload",
        fd
      );
      enqueueSnackbar("Uploaded!", { variant:"success" });
      return data?.data?.[0]?.imgurl ?? null;
    } catch(e) {
      enqueueSnackbar(e.response?.data?.message || "Upload failed",{variant:"error"});
      throw e;
    } finally { setLoading(false); }
  };

  return { upload, loading };
}
